"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPurchaseBar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/commerce/order-product-item");
require("@/components/domains/commerce/product-price");
/**
 * mm-product-purchase-bar
 * 상품 상세 하단에 고정되어 보고 있는 상품과 가격을 요약하고 구매 동작을 붙잡아 두는 막대.
 * 고정 위치는 mm-fixed-bottom이 맡고, 이 컴포넌트는 막대의 내용과 재질만 소유한다.
 * 구매 버튼은 action 슬롯으로 받는다. 버튼이 aria-controls로 장바구니 시트를 가리켜야 하는데,
 * id 참조는 shadow 경계를 넘지 못해 버튼이 페이지 쪽 light DOM에 있어야 하기 때문이다.
 */
let ProductPurchaseBar = class ProductPurchaseBar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.option = '';
        this.imageSrc = '';
        this.price = '';
        this.originalPrice = '';
        this.discount = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-order-product-item
        image-src=${this.imageSrc}
        name=${this.name}
        option=${this.option}
      ></mm-order-product-item>
      <mm-product-price
        size="large"
        price=${this.price}
        original-price=${this.originalPrice}
        discount=${this.discount}
      ></mm-product-price>
      <slot name="action"></slot>
    `;
    }
};
ProductPurchaseBar.styles = (0, lit_1.css) `
    :host {
      display: flex;
      align-items: center;
      gap: var(--space-4);
      padding: var(--space-3) var(--layout-padding-inline);
      border-top: var(--material-chrome-border);
      background: var(--material-chrome-background-color);
      box-shadow: var(--material-chrome-shadow);
      backdrop-filter: var(--material-chrome-backdrop-filter);
      -webkit-backdrop-filter: var(--material-chrome-backdrop-filter);
    }

    /* 상품 요약이 남는 폭을 가져가 가격을 구매 버튼 곁으로 민다. */
    mm-order-product-item {
      flex: 1;
      min-width: 0;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPurchaseBar.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPurchaseBar.prototype, "option", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'image-src' })
], ProductPurchaseBar.prototype, "imageSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPurchaseBar.prototype, "price", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'original-price' })
], ProductPurchaseBar.prototype, "originalPrice", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ProductPurchaseBar.prototype, "discount", void 0);
ProductPurchaseBar = __decorate([
    (0, decorators_js_1.customElement)('mm-product-purchase-bar')
], ProductPurchaseBar);
exports.ProductPurchaseBar = ProductPurchaseBar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdC1wdXJjaGFzZS1iYXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwcm9kdWN0LXB1cmNoYXNlLWJhci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELDREQUF5RDtBQUN6RCx1REFBb0Q7QUFFcEQ7Ozs7OztHQU1HO0FBRUksSUFBTSxrQkFBa0IsR0FBeEIsTUFBTSxrQkFBbUIsU0FBUSxnQkFBVTtJQUEzQzs7UUFvQnVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxXQUFNLEdBQUcsRUFBRSxDQUFBO1FBQ2EsYUFBUSxHQUFHLEVBQUUsQ0FBQTtRQUNyQyxVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ21CLGtCQUFhLEdBQUcsRUFBRSxDQUFBO1FBQy9DLGFBQVEsR0FBRyxFQUFFLENBQUE7SUFrQjNDLENBQUM7SUFoQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O29CQUVLLElBQUksQ0FBQyxRQUFRO2VBQ2xCLElBQUksQ0FBQyxJQUFJO2lCQUNQLElBQUksQ0FBQyxNQUFNOzs7O2dCQUlaLElBQUksQ0FBQyxLQUFLO3lCQUNELElBQUksQ0FBQyxhQUFhO21CQUN4QixJQUFJLENBQUMsUUFBUTs7O0tBRzNCLENBQUE7SUFDSCxDQUFDOztBQXpDTSx5QkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FrQmxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2tEQUFZO0FBQ2E7SUFBbkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsV0FBVyxFQUFFLENBQUM7b0RBQWM7QUFDckM7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2lEQUFXO0FBQ21CO0lBQXhELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGdCQUFnQixFQUFFLENBQUM7eURBQW1CO0FBQy9DO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztvREFBYztBQXpCOUIsa0JBQWtCO0lBRDlCLElBQUEsNkJBQWEsRUFBQyx5QkFBeUIsQ0FBQztHQUM1QixrQkFBa0IsQ0EyQzlCO0FBM0NZLGdEQUFrQiJ9